import { render, staticRenderFns } from "./M2hWeFitter.vue?vue&type=template&id=38307fc9&scoped=true&"
import script from "./M2hWeFitter.vue?vue&type=script&lang=js&"
export * from "./M2hWeFitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38307fc9",
  null
  
)

export default component.exports